export const tags = {
	newTagList: '/api/insureapi/officialIndexService/newTagList',
	hotTag: '/api/insureapi/officialIndexService/hotTag',
	webTagSiteMap: '/api/insureapi/officialIndexService/webTagSiteMap',
	groupTagList: '/api/insureapi/officialIndexService/groupTagList',
	categoryTree: '/insureapi/officialIndexService/categoryTree'
}

export default [
	{
		name: 'newTagList',
		method: 'POST',
		desc: '最新标签',
		path: '/insureapi/officialIndexService/newTagList'
	},
	{
		name: 'hotTag',
		method: 'POST',
		desc: '热门标签',
		path: '/insureapi/officialIndexService/hotTag'
	},
	{
		name: 'webTagSiteMap',
		method: 'POST',
		desc: '网站地图',
		path: '/insureapi/officialIndexService/webTagSiteMap'
	},
	{
		name: 'groupTagList',
		method: 'POST',
		desc: '标签列表查询',
		path: '/insureapi/officialIndexService/groupTagList'
	},
	{
		name: 'categoryTree',
		method: 'POST',
		desc: '栏目树查询',
		path: '/insureapi/officialIndexService/categoryTree'
	}
];
